import React,{useState,useCallback} from 'react'
import {Link} from 'gatsby'
import Style from './Style.module.scss'
import {Modal,Button,Form, Container, Row, Col} from 'react-bootstrap'
import { MdMailOutline,MdPersonPin,MdBuild ,MdCreate} from "react-icons/md"

const Menu = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [description, setDescription] = useState('')
  const [show, setShow] = useState(false)

  const handleClose = useCallback(() => {
    setShow(false)
  }, [setShow]);

  
  const handleShow = () => setShow(true);
  
  const inputName = useCallback((e) => {
    setName(e.target.value)
    console.log(setName(e.target.value))
  },[setName])

  const inputEmail = useCallback((e) => {
    setEmail(e.target.value)
  },[setEmail])

  const inputDescription = useCallback((e) => {
    setDescription( e.target.value)
  },[setDescription])

  const validateEmailFormat = (email) => {
    const regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    return regex.test(email)
  }

  const validateRequiredInput = (...args) => {
    let isBlank = false;
    for (let i = 0; i < args.length; i=(i+1)|0) {
        if (args[i] === "") {
            isBlank = true;
        }
    }
    return isBlank
  };

  
  
  const submitForm = () => {
    const isBlank = validateRequiredInput(name, email, description)
    const isValidEmail = validateEmailFormat(email)

    if (isBlank) {
      alert('必須入力欄が空白です。')
      return false
    } else if (!isValidEmail) {
      alert('メールアドレスの書式が異なります。')
      return false
    } else {
      const payload = {
          
          text: 'お問い合わせがありました\n'
              + 'お名前: ' + name + 'さん\n'
              + 'メールアドレス: ' + email + '\n'
              + '【問い合わせ内容】\n' + description
      }
    const url = 'https://hooks.slack.com/services/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'
    console.log(payload)
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload)
        
      }).then(() => {
        alert('送信が完了しました。追ってご連絡致します。')
          setName('')
          setEmail('') 
          setDescription('') 
        return handleClose()
      }).catch(() => {
        alert('送信が完了しました。追ってご連絡致します。')
        return false
      })
    }
  }
  
  return (
    <Container >
      <Row className={Style.exampleCollapseText} >
        <Col xs={6} sm={3}>
          <Link className={Style.links} to={'/'}><MdPersonPin/>About</Link>
        </Col>
        <Col xs={6} sm={3}>
          <Link className={Style.links} to={'/Portfolio'}><MdBuild/>Portfolio</Link>
        </Col>
        <Col xs={6} sm={3}>
          <Link className={Style.links} to={'/Blog'}><MdCreate/>Blog</Link>
        </Col>
        <Col xs={6} sm={3}>
          <a className={Style.links} onClick={handleShow}>
            <MdMailOutline/>Contact
          </a>

          <Modal
            show={show}
            onHide={handleClose}
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>お問い合わせ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Form>
              <Form.Group controlId="exampleForm.ControlText">
                <Form.Label>お名前</Form.Label>
                <Form.Control type="text" rows="1" value={name} onChange={inputName}/>
              </Form.Group>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Eメールアドレス</Form.Label>
                <Form.Control type="email" onChange={inputEmail} value={email} />
              </Form.Group>
              <Form.Group controlId="exampleForm.ControlTextarea">
                <Form.Label>お問い合わせ内容</Form.Label>
                <Form.Control as="textarea" rows="7" onChange={inputDescription} value={description}/>
              </Form.Group>
              <div className={Style.contactButton}>
                <Button  variant="primary" type="submit" onClick={submitForm}>
                  送信する
                </Button>
              </div>
            </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </Col>
      </Row>
      
    </Container>
  )
}

export default Menu
